// extracted by mini-css-extract-plugin
export default {"region":"prch3","row":"O9F9T","opened":"XB5k2","info":"CoIJ6","regionName":"SPG7e","checkbox":"ZsdoA","arrow":"HcDc1","counter":"dtOOP"};